import { Link } from "react-router-dom";
import { ArrowLeft } from "../../../Atoms/Icons";

export default function Breadcrumb({ job }) {
  return (
    <div className="breadcrumb-bar pb-3">
      <div className="containers-min mx-auto px-4 ">
         <Link to="/careers/openings" className="btn-vm-morph">
            <span className="morph-icon"><ArrowLeft size={16} /></span>
            <span>Back to Careers</span>
          </Link>
        <nav aria-label="breadcrumb" className="flex gap-2 text-base pt-6">
          <Link to="/" className="breadcrumb-item">Home</Link>
          <span>/</span>
          <Link to="/careers/openings" className="breadcrumb-item">Careers</Link>
          <span>/</span>
          <span className="breadcrumb-item active">{job.title}</span>
        </nav>
      </div>
    </div>
  );
}
